import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Divider
} from '@mui/material';
import {
  Info as InfoIcon,
  Update as UpdateIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import VersionDisplay from '../components/VersionDisplay';
import { APP_NAME } from '../config/constants';

function AboutPage() {
  const { t } = useTranslation();
  
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          {t('aboutPage.title', { appName: APP_NAME })}
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          {t('aboutPage.subtitle')}
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {/* Informations générales */}
        <Grid item xs={12} md={6}>
          <Card sx={{ borderRadius: 2 }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <InfoIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6">
                  {t('aboutPage.generalInfo')}
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" paragraph>
                {t('aboutPage.description', { appName: APP_NAME })}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>{t('aboutPage.features')}</strong>
              </Typography>
              <Box component="ul" sx={{ mt: 1, pl: 2 }}>
                <Typography component="li" variant="body2" color="text.secondary">
                  {t('aboutPage.feature1')}
                </Typography>
                <Typography component="li" variant="body2" color="text.secondary">
                  {t('aboutPage.feature2')}
                </Typography>
                <Typography component="li" variant="body2" color="text.secondary">
                  {t('aboutPage.feature3')}
                </Typography>
                <Typography component="li" variant="body2" color="text.secondary">
                  {t('aboutPage.feature4')}
                </Typography>
                <Typography component="li" variant="body2" color="text.secondary">
                  {t('aboutPage.feature5')}
                </Typography>
                <Typography component="li" variant="body2" color="text.secondary">
                  {t('aboutPage.feature6')}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Versions */}
        <Grid item xs={12}>
          <Card sx={{ borderRadius: 2 }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <UpdateIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6">
                  {t('aboutPage.versions')}
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" paragraph>
                {t('aboutPage.versionsDescription')}
              </Typography>
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center',
                py: 2,
                backgroundColor: '#f8f9fa',
                borderRadius: 1
              }}>
                <VersionDisplay />
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Auteur et licence */}
        <Grid item xs={12}>
          <Paper sx={{ p: 3, textAlign: 'center', backgroundColor: '#f8f9fa', borderRadius: 2 }}>
            <Typography variant="body2" color="text.secondary" dangerouslySetInnerHTML={{ __html: t('aboutPage.developedBy') }} />
            <Divider sx={{ my: 1 }} />
            <Typography variant="body2" color="text.secondary">
              {t('aboutPage.license', { year: new Date().getFullYear() })}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default AboutPage;
